import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ ...filter }) => {
  const filterStr = filter ? convertFilterRequestUrl(filter, ['showActiveOnly']) : '';
  const getBusinessUnit = `getBusinessUnit(input: ${filterStr})`;
  return gql`
    query {
      ${getBusinessUnit} {
        id
        index
        name
        description
        shortName
        code
        enterprise
        division
        legalEntity
        locationIndex
        status
        address {
          city
          state
          country
        }
      }
    }
  `;
};
